const ClientInvoiceReportGroupOptionsArray = [
  { value: null, label: '' },
  { value: 'Ad-Hoc', label: 'Ad-Hoc' },
  //{ value: 'Fee Reason', label: 'Fee Reason' },
  { value: 'Location', label: 'Location Name' },
  { value: 'Country', label: 'Country' },
  { value: 'Project', label: 'Project' },
  //{ value: 'Location Group', label: 'Location Group' },
  { value: 'Evaluation Date', label: 'Evaluation Date' },
  { value: 'Level2', label: 'Location Level 2' },
  { value: 'Level3', label: 'Location Level 3' },
  { value: 'Level4', label: 'Location Level 4' },
  { value: 'Level5', label: 'Location Level 5' },
  { value: 'Wave', label: 'Assignment Wave' },
];

export default ClientInvoiceReportGroupOptionsArray;
